import r from "classnames";
const C = /^\s+|\s+(?=\s|$)/g, o = (n, t) => (t ? typeof t == "string" ? t : (t == null ? void 0 : t.value) ?? "" : "").replace(C, "") || n.replace(C, "") || void 0, g = (n, t, e) => r(o("", e), o(o("", t) || "", n)), E = (n, t = [], e = []) => r([...e, ...t == null ? void 0 : t.map((p) => n ? `${n}--${p}` : p)]);
export {
  g as getClassName,
  E as getModifierClasses,
  o as parseClassName
};
